import React from 'react';
import ReactDOM from 'react-dom';
import Tether from './xtether';
import listenDOM from 'src/logic/listenDOM';
import { Provider } from 'react-redux';
import {popoverZIndex, popoverOZIndex} from 'src/styles/variables.scss';


export default class Tethered extends React.Component {

  static contextTypes = {
    store: React.PropTypes.object,
  };

  static propTypes = {
    store: React.PropTypes.object,
    className: React.PropTypes.string,
    children: React.PropTypes.element.isRequired,
    getTarget: React.PropTypes.func.isRequired,
    onOutClick: React.PropTypes.func,
  };


  componentDidMount() {
    this.elementContainer = document.createElement('div');
    this.elementContainer.style.zIndex = this.props.onTop ? popoverOZIndex : popoverZIndex;
    this.elementContainer.style.position = 'absolute';
    if (this.props.className) {
      this.elementContainer.className = this.props.className;
    }

    document.body.appendChild(this.elementContainer);
    this.renderElement();
    this.unlistenDocument = listenDOM(document, 'click', this.onDocumentClick.bind(this), false);
  }

  componentWillReceiveProps({className}) {
    if (className !== this.props.className) {
      this.elementContainer.className = className;
    }
  }

  componentDidUpdate() {
    setTimeout(this.renderElement, 0);
  }

  componentWillUnmount() {
    this.unlistenDocument();
    this.tether.destroy();
    ReactDOM.unmountComponentAtNode(this.elementContainer);
    if (this.elementContainer.parentNode) {
      this.elementContainer.parentNode.removeChild(this.elementContainer);
    }
  }

  onDocumentClick(event) {
    if (!this.reactComponent) {
      return;
    }

    const isChild = this.tether.element.contains(event.target);

    if (!isChild && this.props.onOutClick) {
      this.props.onOutClick(event);
    }
  }

  renderElement = () => {
    const child = React.Children.only(this.props.children);
    const store = this.props.store || this.context.store;
    const element = store ? <Provider store={store}>{child}</Provider> : child;

    this.reactComponent = ReactDOM.render(element, this.elementContainer);

    const tetherOptions = {
      ...this.props,
      element: this.elementContainer,
      target: this.props.getTarget(),
      children: undefined,
      getTarget: undefined,
      className: undefined,
      constraints: [
        {
          to: 'scrollParent',
          attachment: 'together',
          pin: true
        }
      ]
    };

    if (this.tether) {
      this.tether.setOptions(tetherOptions);
    } else {
      this.tether = new Tether(tetherOptions);
    }
  };

  render() {
    return null;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Tethered.jsx
 **/